// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bfz_a bhy_wj bhy_ss bhy_xl"};